import HeaderLayout from '../../../../components/HeaderLayout';
import Box from '../../components/Box';
import styles from './styles.module.css';

function SentMail() {
  return (
    <HeaderLayout title="マイページ">
      <Box title="認証メール送信完了">
        <div className={styles.summary}>メールを確認してください</div>
        <div className={styles.details}>
          認証メールを送信しました。
          <br />
          メール本文に記載されている認証URLをクリックし、変更を完了してください。
        </div>
      </Box>
    </HeaderLayout>
  );
}

export default SentMail;
